import { reactive } from "vue";
import { projectLibrary } from "../../data";
import { appStore } from "../../stores/app";
import { Project, ProjectFilter } from "../../types/type_def";

/**
 * The paged project list on the configurations page, shared by the page and the project modals.
 */
export const projectList = reactive({
    filter: {
        search: "",
        hideInactive: false,
        currentPage: 1,
        itemsShown: 20,
    } as ProjectFilter,
    projects: [] as Project[],
    pageCount: 0,
});

/** Loads the current page of projects (keeps the page number within range). */
export async function loadProjects() {
    appStore.loading = true;
    try {
        const filter = projectList.filter;
        const pageCount = () => Math.ceil(projectLibrary.count / filter.itemsShown);

        if (filter.currentPage > pageCount())
            filter.currentPage = pageCount();
        if (filter.currentPage < 1)
            filter.currentPage = 1;

        await projectLibrary.getAllProjects(filter);

        projectList.projects = [...projectLibrary.projects];
        projectList.pageCount = pageCount();
    } finally {
        appStore.loading = false;
    }
}

export function goToPage(page: number) {
    projectList.filter.currentPage = Math.min(Math.max(page, 1), Math.max(projectList.pageCount, 1));
    return loadProjects();
}

/** Status number -> name used in translation keys and CSS classes */
export function statusName(status: number): string {
    switch (Number(status)) {
        case 0: return "inactive";
        case 1: return "active";
        case 2: return "ordered";
    }
}
